var exports = {
  "kL": "container__eGUS9l",
  "Kk": "icon__FHfOus",
  "h_": "description__syZvSU",
};

module.exports = exports;
